import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';
import { FaHome, FaPlayCircle, FaPlusCircle, FaBell, FaUserCircle } from 'react-icons/fa';
import { get_massage, get_unread } from '../data/massage_data';
import { getSocket } from '../store/socketClient';
import '../styles/header.css';

const Header = () => {
  const translations = useSelector((state) => state.lang_reduse?.lang || {});
  const userId = useSelector((state) => state.authReduse?.id);
  const unreadTotal = useSelector((state) => state.UsersReduse?.unreadTotal || 0);
  const dispatch = useDispatch();
  const location = useLocation();
  const navRef = useRef(null);
  const [blob, setBlob] = useState({ left: 0, top: 0, width: 0, height: 0 });
  const [moving, setMoving] = useState(false);
  const [landing, setLanding] = useState(false);

  const links = [
    { to: '/', label: translations.home || 'Home', icon: <FaHome /> },
    { to: '/watch', label: translations.watch || 'Watch', icon: <FaPlayCircle /> },
    { to: '/shot-video', label: translations.shotavideo || 'Create', icon: <FaPlusCircle /> },
    { to: '/notifications', label: translations.notifications || 'Alerts', icon: <FaBell /> },
    { to: '/profile', label: translations.profile || 'Profile', icon: <FaUserCircle /> },
  ];

  const updateBlob = () => {
    const nav = navRef.current;
    const active = nav?.querySelector('.fresh-header__link.active');
    if (!nav || !active) return;
    const navBox = nav.getBoundingClientRect();
    const tabBox = active.getBoundingClientRect();
    setBlob({
      left: tabBox.left - navBox.left,
      top: tabBox.top - navBox.top,
      width: tabBox.width,
      height: tabBox.height
    });
  };

  useLayoutEffect(() => {
    setMoving(true);
    setLanding(false);
    updateBlob();
    const moveTimer = window.setTimeout(() => {
      setMoving(false);
      setLanding(true);
    }, 380);
    const landTimer = window.setTimeout(() => setLanding(false), 820);
    return () => {
      window.clearTimeout(moveTimer);
      window.clearTimeout(landTimer);
    };
  }, [location.pathname, translations]);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav || typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(updateBlob);
    observer.observe(nav);
    window.addEventListener('resize', updateBlob);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', updateBlob);
    };
  }, []);

  useEffect(() => {
    if (!userId) return undefined;
    dispatch(get_unread());
    const socket = getSocket();
    const onMessage = (message) => {
      if (String(message?.to_user) === String(userId) || String(message?.from_user) === String(userId)) {
        dispatch(get_massage());
      }
    };
    socket.on('send message', onMessage);
    const interval = window.setInterval(() => {
      if (!socket.connected) dispatch(get_unread());
    }, 60000);
    return () => {
      socket.off('send message', onMessage);
      window.clearInterval(interval);
    };
  }, [dispatch, userId, location.pathname]);

  return (
    <header className={`fresh-header${landing ? ' is-landing' : ''}`}>
      <nav className="fresh-header__nav" ref={navRef}>
        <span
          className={`fresh-header__blob${moving ? ' is-moving' : ''}`}
          style={{
            opacity: blob.width ? 1 : 0,
            transform: `translate3d(${blob.left}px, ${blob.top}px, 0)`,
            width: blob.width,
            height: blob.height
          }}
          aria-hidden="true"
        />
        {links.map(({ to, icon, label }) => {
          const needsAccount = to === '/shot-video' || to === '/notifications'
          const signedIn = Boolean(userId)
          const dest = needsAccount && !signedIn
            ? { pathname: '/auth', state: { from: to } }
            : to
          return (
          <NavLink
            key={to}
            to={dest}
            end={to === '/'}
            title={label}
            className={({ isActive }) =>
              `fresh-header__link${isActive && !(needsAccount && !signedIn) ? ' active' : ''}`
            }
          >
            <span className="fresh-header__icon">
              {icon}
              {to === '/notifications' && unreadTotal > 0 ? (
                <b className="fresh-header__badge">{unreadTotal > 99 ? '99+' : unreadTotal}</b>
              ) : null}
            </span>
            <span className="fresh-header__label">{label}</span>
          </NavLink>
          )
        })}
      </nav>
    </header>
  );
};

export default Header;
